import {
    SETTINGS_CHECKOUT_UPSELL_ENABLED,
    SETTINGS_ORDER_CONFIRMATION_ENABLED,
    SETTINGS_ORDER_MIN_PRICE_LIMIT,
    SETTINGS_ORDER_MIN_PRICE_LIMIT_ENABLED,
} from '../../constants';
import { type SettingsValue, useSettingsFactory } from './useSettingsFactory';

export type SettingsOrderConfirmationEnabled = SettingsValue<typeof SETTINGS_ORDER_CONFIRMATION_ENABLED>;

export const useSettingsOrder = () =>
    useSettingsFactory({
        settingsCheckoutUpsellEnabled: { path: SETTINGS_CHECKOUT_UPSELL_ENABLED },
        settingsOrderConfirmationEnabled: {
            path: SETTINGS_ORDER_CONFIRMATION_ENABLED,
        },
        settingsOrderMinPriceEnabled: { path: SETTINGS_ORDER_MIN_PRICE_LIMIT_ENABLED },
        settingsOrderMinPriceLimit: { path: SETTINGS_ORDER_MIN_PRICE_LIMIT },
    });
